import { render, staticRenderFns } from "./court.vue?vue&type=template&id=b6a3d7a6&"
import script from "./court.vue?vue&type=script&lang=ts&"
export * from "./court.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "court.vue"
export default component.exports